import { PRESET_STAKE_COUNT, VALID_GAME_ID } from '@root/constants';
import { betValuesSelector } from '@root/store/slices/betValuesSlice';
import {
  useActions,
  useGetGamePreferencesQuery,
  useTypedSelector,
} from '@root/store/store';
import { useAuth, useBetLimits, useStakePresets } from '@shared/hooks';

// The player's saved stakes, not slice placeholders. Endpoint is this game's.
export function useChipValues(): { values: number[] } {
  const { user } = useAuth();
  const { values } = useTypedSelector(betValuesSelector);
  const { setBetValues, setCurrentBetAmount } = useActions();
  const { minBet } = useBetLimits();

  const { data } = useGetGamePreferencesQuery(
    { userId: user?.id || 0, gameId: VALID_GAME_ID },
    { skip: !user }
  );

  useStakePresets({
    preferences: data?.data,
    presetCount: PRESET_STAKE_COUNT,
    minBet,
    setBetValues,
    setCurrentBetAmount,
  });

  return { values };
}
